import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || (window.location.hostname === 'localhost' ? 'http://localhost:5000/api' : 'https://enquete.magboye.com/api');
export const API_BASE_URL = API_BASE.replace('/api', '');

const api = axios.create({
  baseURL: API_BASE,
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('admin_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Auth
export const login = (credentials) => api.post('/auth/login', credentials);

// Questions (public)
export const getQuestions = () => api.get('/questions');
export const getQuartiers = () => api.get('/questions/quartiers');

// Questions (admin)
export const getAllQuestions = () => api.get('/questions/all');
export const createQuestion = (data) => api.post('/questions', data);
export const updateQuestion = (id, data) => api.put(`/questions/${id}`, data);
export const deleteQuestion = (id) => api.delete(`/questions/${id}`);
export const reorderQuestions = () => api.post('/questions/reorder');

// Survey
export const startSurvey = (data) => api.post('/survey/start', data);
export const submitResponse = (data) => api.post('/survey/respond', data, {
  headers: data instanceof FormData ? { 'Content-Type': 'multipart/form-data' } : {}
});
export const completeSurvey = (data) => api.post('/survey/complete', data);

// Admin
export const getStats = (filters = {}) => {
  const params = new URLSearchParams();
  if (filters.period) params.append('period', filters.period);
  if (filters.source) params.append('source', filters.source);
  if (filters.quartier) params.append('quartier', filters.quartier);
  const qs = params.toString();
  return api.get(`/admin/stats${qs ? '?' + qs : ''}`);
};
export const getResponses = (page = 1, limit = 20) => api.get(`/admin/responses?page=${page}&limit=${limit}`);
export const getSessionResponses = (sessionId) => api.get(`/admin/responses/${sessionId}`);
export const deleteSession = (sessionId) => api.delete(`/admin/sessions/${sessionId}`);
export const exportData = () => api.get('/admin/export');
export const exportExcel = () => api.get('/admin/export-excel', { responseType: 'blob' });
export const getQuestionStats = (questionId) => api.get(`/admin/question-stats/${questionId}`);
export const getDomainSatisfaction = () => api.get('/admin/domain-satisfaction');
export const getPriorities = () => api.get('/admin/priorities');
export const getComments = () => api.get('/admin/comments');

// Settings
export const getIntro = () => api.get('/settings/intro');
export const updateIntro = (data) => api.put('/settings/intro', data, {
  headers: data instanceof FormData ? { 'Content-Type': 'multipart/form-data' } : {}
});

// Invitations
export const createInvitation = (data) => api.post('/invitations', data);
export const createAdminInvitation = (data) => api.post('/invitations/admin', data);
export const validateInvitation = (token) => api.get(`/invitations/validate/${token}`);
export const consumeInvitation = (token, data) => api.post(`/invitations/use/${token}`, data);
export const getInvitations = () => api.get('/invitations');
export const deleteInvitation = (id) => api.delete(`/invitations/${id}`);
export const changePassword = (data) => api.put('/auth/change-password', data);

export default api;
